import { render, staticRenderFns } from "./SvgShapeModal.vue?vue&type=template&id=5634a6b6&scoped=true"
import script from "./SvgShapeModal.vue?vue&type=script&lang=js"
export * from "./SvgShapeModal.vue?vue&type=script&lang=js"
import style0 from "./SvgShapeModal.vue?vue&type=style&index=0&id=5634a6b6&prod&scoped=true&lang=css"
import style1 from "./SvgShapeModal.vue?vue&type=style&index=1&id=5634a6b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5634a6b6",
  null
  
)

export default component.exports